module.exports = __webpack_public_path__ + "static/img/train_back.a29ead81.png";